module.exports = __webpack_public_path__ + "static/media/heinrichsdoerferweg_ueberblick.83ca1a10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/projekte/heinrichsdoerferweg_ueberblick.jpg
// module id = 354
// module chunks = 0